import {finalize} from 'rxjs/operators';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { DLCompany } from './company';
import { DLCompanyService } from './company.service';
import { NotifierService, DialogService } from '../../ui';
import { FormControl, Validators } from '@angular/forms';
import { DLLedger } from './ledger';
import { sortBy } from 'lodash';

type ViewMode = 'view' | 'new' | 'edit';

@Component({
  templateUrl: './company-edit.component.html',
})
export class DLCompanyEditComponent implements OnInit, AfterViewInit {

  company: DLCompany

  mode: ViewMode
  title: string

  @ViewChild('nameInput')
  nameInput: ElementRef

  name: FormControl

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private companyService: DLCompanyService,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  initForm() {
    // name
    this.name = new FormControl(this.company.name, [
      Validators.required
    ]);

    this.name.valueChanges.subscribe((value) => {
      this.company.name = value;
    });
  }
  
  ngAfterViewInit() {
    // Focus name input
    if (this.nameInput) {
      this.nameInput.nativeElement.focus();
    }
  }

  ngOnInit() {

    this.mode = this.route.routeConfig.data.mode;
    this.title = this.route.routeConfig.data.title;

    switch (this.mode) {
      case 'new': 
        {
          this.company = new DLCompany();

          this.initForm();
        }
        break;

      case 'edit':
        {
          // Get the company
          this.notifier.startProgress();

          this.route.data.subscribe((data) => {
            this.company = data.company;

            this.initForm();

            this.notifier.endProgress();
          });
        }
        break;

      case 'view':
        {
          // Get the company
          this.notifier.startProgress();

          this.route.data.subscribe((data) => {
            this.company = data.company;

            this.notifier.endProgress();
          });
        }
        break;
    }

    // Sort ledgers
    if (this.company) {
      this.company.ledgers = sortBy(this.company.ledgers, l => l.name);
    }
  }

  save() {
    if (!this.company || !this.company.valid) {
      return;
    }

    let notifier = this.notifier;

    notifier.updateProgress(20);

    function onComplete() {
      notifier.endProgress();
    }

    switch (this.mode) {
      case 'new':
        {
          this.companyService
            .create(this.company).pipe(
            finalize(onComplete))
            .subscribe((company) => {
              this.company = company;

              this.notifier.success('Société créée avec succès');

              // Got to view screen
              this.router.navigate(['documents-ledger', 'companies', company.id]);
            });
        }
        break;

      case 'edit':
        {
          this.companyService
            .update(this.company.id, this.company).pipe(
            finalize(onComplete))
            .subscribe((company) => {
              this.company = company;

              this.notifier.success('Société enregistrée avec succès');

              // Got to view screen
              this.router.navigate(['documents-ledger', 'companies', company.id]);
            });
        }
        break;
    }
  }

  cancel() {
    if (this.mode === 'edit') {
      this.router.navigate(['documents-ledger', 'companies', this.company.id]);
    }
    else {
      this.router.navigate(['documents-ledger', 'companies']);
    }
  }

  delete() {
    this.dialogService
      .confirmDelete('Voulez-vous supprimer cette société?')
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.companyService
          .delete(this.company.id)
          .subscribe((id) => {
            this.notifier.success('Société supprimée avec succès');

            this.router.navigate(['documents-ledger', 'companies']);

          }, (err) => {
            this.notifier.endProgress();
          });
      });
    
    return false;
  }

  showLedger(ledger: DLLedger) {
    this.router.navigate([this.router.url, ledger.id]);
  }
}
